import {
  title,
  button,
} from './style'
import { Button } from 'components/Button'
import { Spacer } from 'components/Spacer'
import { Subtitle02 } from 'components/Typography/Subtitle02'
import { ConfirmFinishProps } from 'types'
import { Color } from 'utils/variables'

export const ConfirmFinish = ({onFinish}:ConfirmFinishProps) => {
  return (
    <>
      <div className={title}>
        <Subtitle02 color={Color.LightBlack}>この通話を終了しますか？</Subtitle02>
      </div>
      <Spacer size={26}/>
      <Button size="large" classname={button} onClick={() => onFinish()}>通話を終了する</Button>
    </>
  );
}

